import React from 'react';

import img_me from '../../images/Polymedia-Peter_van_der_Meer.jpg';


export default class extends React.Component {

  render() {
    return (
      <div className="col-2" style={{margin:"0 auto", display:"block"}}>
        <div className="card more-rounded card-black project">
          <div className="project-img">
            <a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer">
              <img src={img_me} alt="Foto Peter van der Meer" style={{maxWidth:"initial"}} />
            </a>
          </div>
          <div className="project-description" style={{height:"100%"}}>
            <h1>
              <a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer">Peter van der Meer</a>
            </h1>
            <h2>Autoriteit Bouwer & Eigenaar bij Ghostin</h2>
            <p>
              Mijn naam is Peter, en ik beschrijf mezelf als Techie en Gamer. Het schrijven is bij mij begonnen bij het bouwen van mijn eigen webapplicaties. Ik bouwde maandenlang aan een applicatie en vervolgens kwam er niemand op af, ik had er dan ook niemand over verteld. Ik realiseerde mij dat ik meer met marketing moest gaan doen. Nu, na tientallen websites, blogs, en sociale pagina's geschreven te hebben, heb ik een heleboel ervaring opgedaan met marketing en doelgericht schrijven. Ik begon met een heel algemeen marketing bureau voor eigenlijk iedereen, met een aanbod van webbouw tot en met SEO en van social media beheer tot en met blogs schrijven. Daar kwam niemand enthousiast op af. Toen zag ik na maanden op LinkedIn andere mensen die zich enkel richten op LinkedIn, en omdat ik al maanden 7 berichten per week aan het schrijven was, realiseerde ik mij dat dit de perfecte richting voor mij was. Inmiddels heb ik honderden profielen geanalyseerd, heb ik feedback van experts ontvangen en toegepast bij mijn klanten, en heb ik meerdere tevreden klanten die hun gewenste resultaten zagen. Van een ambtenaar bij de rijksoverheid die heel erg moest wennen aan wekelijkse activiteit op het profiel maar dit nu met plezier doet, tot een leiderschapscoach die eindelijk discussies kreeg onder de berichten.
            </p>
            <div style={{marginBottom:"1em"}}>
              <a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer" style={{marginRight:"32px"}} className="gold">LinkedIn</a> <a href="/testimonials" className="gold">Testimonials</a>
            </div>
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/components/ArticleBio.js